import RespiratoryConditionForm from "./RespiratoryConditionForm/RespiratoryConditionForm.vue";
import CancerConditionForm from "./CancerConditionForm/CancerConditionForm.vue";
import HeartConditionForm from "./HeartConditionForm/HeartConditionForm.vue";
import StrokeConditionForm from "./StrokeConditionForm/StrokeConditionForm.vue";
import DiabetesConditonForm from "./DiabetesConditionForm/DiabetesConditionForm.vue";
import HypertensionForm from "./HypertensionForm/HypertensionForm.vue";
import CholesterolForm from "./CholesterolForm/CholesterolForm.vue";
import MultiplesclerosisConditionForm from "./MultiplesclerosisConditionForm/MultiplesclerosisConditionForm.vue";
import OtherConditionForm from "./OtherConditionForm/OtherConditionForm.vue";
import NeurologicalConditionForm from "./NeurologicalConditionForm/NeurologicalConditionForm.vue";
import { PrescribedConditionTypes } from "@/entities/conditions";
export { default as MedicalConditionSearch } from "./MedicalConditionSearch.vue";
export { default as MedicalFormBuilder } from "./MedicalFormBuilder.vue";

export type MedicalConditionComponent =
  | { type: PrescribedConditionTypes.Heart; component: typeof HeartConditionForm }
  | { type: PrescribedConditionTypes.Respiratory; component: typeof RespiratoryConditionForm }
  | { type: PrescribedConditionTypes.Cancer; component: typeof CancerConditionForm }
  | { type: PrescribedConditionTypes.Stroke; component: typeof StrokeConditionForm }
  | { type: PrescribedConditionTypes.Diabetes; component: typeof DiabetesConditonForm }
  | { type: PrescribedConditionTypes.Hypertension; component: typeof HypertensionForm }
  | { type: PrescribedConditionTypes.Cholesterol; component: typeof CholesterolForm }
  | { type: PrescribedConditionTypes.Multiplesclerosis; component: typeof MultiplesclerosisConditionForm }
  | { type: PrescribedConditionTypes.Other; component: typeof OtherConditionForm }
  | { type: PrescribedConditionTypes.Neurological; component: typeof NeurologicalConditionForm }

export const conditionComponents = [
    {
        name: "heartCondition",
        type: PrescribedConditionTypes.Heart,
        component: HeartConditionForm,
    },
    {
        name: "respiratoryCondition",
        type: PrescribedConditionTypes.Respiratory,
        component: RespiratoryConditionForm,
    },
    {
        name: "cancerCondition",
        type: PrescribedConditionTypes.Cancer,
        component: CancerConditionForm,
    },
    {
        name: "strokeCondition",
        type: PrescribedConditionTypes.Stroke,
        component: StrokeConditionForm,
    },
    {
        name: "diabetesCondition",
        type: PrescribedConditionTypes.Diabetes,
        component: DiabetesConditonForm,
    },
    {
        name: "hypertensionCondition",
        type: PrescribedConditionTypes.Hypertension,
        component: HypertensionForm,
    },
    {
        name: "cholesterolCondition",
        type: PrescribedConditionTypes.Cholesterol,
        component: CholesterolForm,
    },
    {
        name: "multiplesclerosisCondition",
        type: PrescribedConditionTypes.Multiplesclerosis,
        component: MultiplesclerosisConditionForm,
    },
    {
        name: "otherCondition",
        type: PrescribedConditionTypes.Other,
        component: OtherConditionForm,
    },
    {
        name: "neurologicalCondition",
        type: PrescribedConditionTypes.Neurological,
        component: NeurologicalConditionForm,
    },
] as const;
